import styled from 'react-emotion'
import { color } from 'bvdash/styles'

export default styled.span(
  props => props.over && color.carnation,
  `
    white-space: nowrap;
  `
)
